<template lang="pug">
#ministries
  section.section.page-section.container.is-fluid
    spinner(v-if="settings.loading")
    .blocks(v-else)
      .block(
        v-for="(ministry, $index) in ministries"
        :key="ministry.id"
        :class="{ 'is-even': $index % 2 === 0, 'is-odd': $index % 2 !== 0 }"
      )
        .block-image
          router-link(:to="{ name: 'ministry', params: { id: ministry.key } }")
            cl-img(
              v-if="ministry._embedded.header_image"
              :cl-id="ministry._embedded.header_image.cl_id"
              :transform="{ width: 640, height: 360 }"
            )
        .block-details
          .content.mobile-padding
            h3.is-size-2-desktop.is-size-3-touch
              router-link(:to="{ name: 'ministry', params: { id: ministry.key } }") {{ ministry.name }}
            p.is-size-5 {{ ministry.short_desc }}
            ministry-links(
              :value="ministry"
              :links="['current_event_count', 'email', 'phone_number']"
            )
</template>

<script>
import { mapGetters } from 'vuex';
import MinistryLinks from '@/components/ministries/MinistryLinks.vue';
import Spinner from '@/components/Spinner.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'ministries-page',
  components: {
    MinistryLinks,
    Spinner,
  },
  computed: {
    ...mapGetters({
      ministries: getterTypes.GET_MINISTRIES,
      page: getterTypes.GET_PAGE,
    }),
  },
  async created() {
    this.settings.loading = true;
    await this.$store.dispatch(actionTypes.DO_GET_MINISTRIES, {
      per: 0,
      zoom: 'header_image',
    });
    this.settings.loading = false;
  },
  data() {
    return {
      settings: {
        loading: false,
        reveal: {
          distance: '35px',
          delay: 250,
        },
      },
    };
  },
};
</script>

<style lang="scss">
#ministries {
  @include blocks;
  .blocks {
    .block {
      .block-image {
        @include blockImage;
      }
    }
  }
}
@media (max-width: $tablet) {
  #ministries {
    .page-section {
      padding-top: 0;
    }
  }
}
</style>
